import { use, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import PopUpWarning, { PopUpCaller } from "../../PopUpWarning/PopUpWarning";
import { TipMouseOutEvent, TipMouseOverEvent } from "../../Tooltip/Tooltip";
import CloudFlareTurnstile from "../../CloudFlareTurnstile/CloudFlareTurnstile";
import { CardBmpMap } from "./itemList/CardBmpMap";
import { PageContext } from "../../Context/PageContext";
import { OpenPopMenu } from "../../PopMenuWindow/PopMenuWindow";
import OpenSlot from "./img/comparison_empty_card_slot.bmp"
import ClosedSlot from "./img/comparison_disable_card_slot.bmp"
import ItemUsable from "./img/usable2.bmp"
import ItemRops from "./img/rops2.bmp"
import ItemArmor from "./img/armor2.bmp"
import ItemWeapon from "./img/weapon2.bmp"
import ItemVisual from "./img/visual2.bmp"
import ItemAmmo from "./img/ammo2.bmp"
import ItemCard from "./img/card2.bmp"
import ItemEtc from "./img/etc2.bmp"
import ItemAll from "./img/allitens.png"
import MobShowToolTip, { MobTipMouseOutEvent, MobTipMouseOverEvent } from "./MobShowToolTip";
import MonsterMap from "./Monsters";
import {MapaMonstro} from "./mobList/MapaMonstro";
import Magnifer from "./img/lupa.png"
import ElementalFilter from "./filters/ElementalFilter";
import TypeFilter from "./filters/TypeFilter";
import SubTypeFilter from "./filters/SubtypeFilter";
import AtributeFilter from "./filters/AtributeFilter";
import ArmorFilter from "./filters/ArmorFilter";
import { ItemListRepoComplete, ItemListRepoConsult} from "./itemList/itemListRepo"
import { ItemIdToNameAndResourceConsult } from "./itemList/itemMapIdToNameAndResourceName"
import { ItemDescriptionMapConsult } from "./itemList/itemDescriptionMap"
import { ItemTypeAndSubTypeConsult } from "./itemList/itemTypeAndSubtype"
import { ItemSlotCountConsult } from "./itemList/itemSlotCount"
import { MobDropByItemNameListConsult } from "./mobList/monsterdrops"
import { MvpDropByItemNameListConsult } from "./mobList/monstermvpdrops"
import MvpType from "./img/montype_mvp.png"

var InvalidEntry = "Valor digitado é invalido. Por favor, digite somente palavras sem caracteres especiais ou apenas o Id do item desejado.";

function ItemsDatabase() {

    let searchAmplitude = 20;

    const {setToolTipContent, setPopMenuContent} = useContext(PageContext)

    const [submitItem, setSubmitItem] = useState(<CloudFlareTurnstile desiredFunction={CloudFlareChalenge}/>)
    const [itemDbList, setItemDbList] = useState([])
    const [filteredList, setFilteredList] = useState([])
    const [splitedList, setSplitedList] = useState([])
    const [nadaEncontrado, setNadaEncontrado] = useState('')

    const [primaryTypeFilter, setPrimaryTypeFilter] = useState("")
    const [typeDescriptionFilter, setTypeDescriptionFilter] = useState("Todos os tipos")

    const [stFilter, setStFilter] = useState(SubTypeFilter)
    const [pFilter, setPFilter] = useState(ElementalFilter)
    const [aFilter, setAFilter] = useState(AtributeFilter)
    const [armFilter, setArmFilter] = useState(ArmorFilter)

    const [subTypeFilter, setSubTypeFilter] = useState("")
    const [propertyFilter, setPropertyFilter] = useState("")
    const [atributeFilter, setAtributeFilter] = useState(["",""])
    const [statusFilter, setStatusFilter] = useState("")
    const [equipFilter, setEquipFilter] = useState("")

    const [selectedInterval, setSelectedInterval] = useState(1)
    const [amountOfIntervals, setAmountOfIntervals] = useState(0)
    const [paginationList, setPaginationList] = useState([<IntervalPartition>0</IntervalPartition>])
    const [resultsFounds, setResultsFounds] = useState(0)
    

    function CloudFlareChalenge() {
        setSubmitItem(<Submit onClick={() => SearchForItem()}>Buscar</Submit>)
    }
    
    const { register, getValues } = useForm();


    function hasCorruptedCharacters(str) {
    
        const corruptedPattern = /[^a-zA-Z0-9_.]/;
        return corruptedPattern.test(str);
    }
    

    function CheckCorrupted(key) {
      const originalValue = key;
    
      if (!originalValue) {
        return undefined;
      }
      
      if (hasCorruptedCharacters(originalValue)) {
        return originalValue;
      } else {
        return originalValue.toLowerCase();
      }
    }

    function styleToggleFilterButton(e) {

        Array.from(e.target.parentNode.children).map((item) => {
            item.style.filter = 'saturate(0)';
            item.style.scale = '1.0';
        });

        e.target.style.filter = 'saturate(1)';
        e.target.style.scale = '1.2';
    }


    function PartionedList() {

        let tempSplitedList = [];

        let interval = selectedInterval;

        let start = (interval-1)*searchAmplitude;

        let end = start + searchAmplitude;

        if(filteredList.length < end) {
            end = filteredList.length;
        }

        for(let i = start ; i < end; i++) {
            tempSplitedList.push(filteredList[i])

        }

        setSplitedList(tempSplitedList)
    }


    function SearchForItem() {

        let tempFilteredList = []

        for(let i = 0; i < itemDbList.length; i++ ) {

            let nameResult = ItemIdToNameAndResourceConsult(itemDbList[i]).identifiedDisplayName.toLowerCase();
            let descriptionResult = ItemDescriptionMapConsult(itemDbList[i]).identifiedDescriptionName.toLowerCase();

            if((nameResult.includes(getValues('InputChave').toLowerCase()) ||
            descriptionResult.includes(getValues('InputChave').toLowerCase()) ||
            itemDbList[i] == getValues('InputChave')) &&
            ItemTypeAndSubTypeConsult(itemDbList[i]).Type.includes(primaryTypeFilter) &&
            ItemTypeAndSubTypeConsult(itemDbList[i]).SubType.includes(subTypeFilter) &&
            ItemDescriptionMapConsult(itemDbList[i]).identifiedDescriptionName.includes(propertyFilter) &&

            (ItemDescriptionMapConsult(itemDbList[i]).identifiedDescriptionName.includes(atributeFilter[0]) || ItemDescriptionMapConsult(itemDbList[i]).identifiedDescriptionName.includes(atributeFilter[1])) &&

            ItemDescriptionMapConsult(itemDbList[i]).identifiedDescriptionName.includes(statusFilter) &&
            ItemDescriptionMapConsult(itemDbList[i]).identifiedDescriptionName.includes(equipFilter)) {
            
            tempFilteredList.push(itemDbList[i]);

            }

        }

        setResultsFounds(tempFilteredList.length);
        setFilteredList(tempFilteredList)
    }

        //let palavra = getValues('InputChave');
        //const regex = /^[a-zA-Zà-úÀ-ÚçÇ]+$/;
        //const regexNum = /^\d+$/;

        //let filter = {
        //    word: palavra,
        //    type: tFilter
        //}

        //if(regex.test(filter.word)) {
        //if(regexNum.test(filter.word)) {
     

    document.addEventListener('keydown', (event) =>{
          if(event.keyCode === 13) {
            SearchForItem();
          }
        })

    function aplicarCores(textoBruto) {
    // Regex para encontrar os padrões de cor, capturando a cor e o texto seguinte
    const regex = /\^([0-9a-fA-F]{6})([^\^]*)/g;

    // Substitui cada padrão de cor por um <span> com o estilo inline
    const textoFormatado = textoBruto.replace(regex, (match, cor, texto) => {
        return `<span style="color:#${cor};">${texto}</span>`;
    });
        
    return textoFormatado;
    }

    function resetarScroll() {
    // Rola para as coordenadas X=0 e Y=0
    window.scrollTo(0, 800);
    }



    useEffect(() => {
        
        let initialItemList = Object.keys(ItemListRepoComplete());
        setItemDbList(initialItemList);

        setTimeout(() => {
            document.getElementById('DatabaseMaster').style.opacity = "1";
        }, 300);
    },[]);

    useEffect(()=>{SearchForItem()}, [itemDbList, primaryTypeFilter, subTypeFilter, equipFilter, propertyFilter, atributeFilter, statusFilter]);
    useEffect(()=>{setAmountOfIntervals(resultsFounds/searchAmplitude)}, [resultsFounds])
    useEffect(()=>{PartionedList()}, [filteredList])
    useEffect(()=>{PartionedList()}, [selectedInterval])

    useEffect(() =>{

        let list = []

            if(selectedInterval > amountOfIntervals +1) {
                setSelectedInterval(1)
            }

            if(amountOfIntervals >= 1){

                for(let i = 1; i <= Math.ceil(amountOfIntervals); i++)
                {
                    list.push(<IntervalPartition onClick={() => setSelectedInterval(i)}>{i}</IntervalPartition>)
                }

            } else {
                list.push(<IntervalPartition>1</IntervalPartition>)
            }
            
        setPaginationList(list);
    },[amountOfIntervals]);


    return(
        <DatabaseContainer>
            <TitleContainer>
                
                <SearchBarContainer>

                <Input
                placeholder='Palavra-chave ou código do item' 
                {...register('InputChave')}/>

                <CategoryContainer>

                    <CategoryItem
                    onClick={(e) => {setPrimaryTypeFilter(""); setTypeDescriptionFilter("Todos os tipos")
                        styleToggleFilterButton(e)}}
                    onMouseOver={(event) => TipMouseOverEvent(event, `Todos`, "rgba(0, 0, 0, 1)")}
                    onMouseLeave={() => TipMouseOutEvent()}
                    img={ItemAll} width={"35px"} height={"35px"}/>

                    <CategoryItem
                    onClick={(e) => {setPrimaryTypeFilter('Usable'); setTypeDescriptionFilter("Consumíveis");
                        styleToggleFilterButton(e)}} 
                    onMouseOver={(event) => TipMouseOverEvent(event, `Consumíveis`, "rgba(0, 0, 0, 1)")}
                    onMouseLeave={() => TipMouseOutEvent()}
                    img={ItemUsable} width={"35px"} height={"35px"}/>

                    <CategoryItem
                    onClick={(e) => {setPrimaryTypeFilter('Cash'); setTypeDescriptionFilter("Cash"); styleToggleFilterButton(e)}}  
                    onMouseOver={(event) => TipMouseOverEvent(event, `Cash`, "rgba(0, 0, 0, 1)")}
                    onMouseLeave={() => TipMouseOutEvent()}
                    img={ItemRops} width={"35px"} height={"35px"}/>

                    <CategoryItem
                    onClick={(e) => {setPrimaryTypeFilter('Armor'); setTypeDescriptionFilter("Armadura"); styleToggleFilterButton(e)}}  
                    onMouseOver={(event) => TipMouseOverEvent(event, `Armadura`, "rgba(0, 0, 0, 1)")}
                    onMouseLeave={() => TipMouseOutEvent()}
                    img={ItemArmor} width={"35px"} height={"35px"}/>

                    <CategoryItem
                    onClick={(e) => {setPrimaryTypeFilter('Weapon'); setTypeDescriptionFilter("Armas"); styleToggleFilterButton(e)}}  
                    onMouseOver={(event) => TipMouseOverEvent(event, `Armas`, "rgba(0, 0, 0, 1)")}
                    onMouseLeave={() => TipMouseOutEvent()}
                    img={ItemWeapon} width={"35px"} height={"35px"}/>

                    <CategoryItem
                    onClick={(e) => {setPrimaryTypeFilter('Visual'); setTypeDescriptionFilter("Visual"); styleToggleFilterButton(e)}}  
                    onMouseOver={(event) => TipMouseOverEvent(event, `Visual`, "rgba(0, 0, 0, 1)")}
                    onMouseLeave={() => TipMouseOutEvent()}
                    img={ItemVisual} width={"35px"} height={"35px"}/>

                    <CategoryItem
                    onClick={(e) => {setPrimaryTypeFilter('Ammo'); setTypeDescriptionFilter("Munição"); styleToggleFilterButton(e)}}  
                    onMouseOver={(event) => TipMouseOverEvent(event, `Munição`, "rgba(0, 0, 0, 1)")}
                    onMouseLeave={() => TipMouseOutEvent()}
                    img={ItemAmmo} width={"35px"} height={"35px"}/>

                    <CategoryItem
                    onClick={(e) => {setPrimaryTypeFilter('Card'); setTypeDescriptionFilter("Carta"); styleToggleFilterButton(e)}}  
                    onMouseOver={(event) => TipMouseOverEvent(event, `Cartas`, "rgba(0, 0, 0, 1)")}
                    onMouseLeave={() => TipMouseOutEvent()}
                    img={ItemCard} width={"35px"} height={"35px"}/>

                    <CategoryItem
                    onClick={(e) => {setPrimaryTypeFilter('Etc'); setTypeDescriptionFilter("Etc"); styleToggleFilterButton(e)}}  
                    onMouseOver={(event) => TipMouseOverEvent(event, `Etc`, "rgba(0, 0, 0, 1)")}
                    onMouseLeave={() => TipMouseOutEvent()}
                    img={ItemEtc} width={"35px"} height={"35px"}/>

                    </CategoryContainer>

                    <Submit onClick={() => SearchForItem()}>
                        <SubmitIcon img={Magnifer} />
                    </Submit>

                </SearchBarContainer>
                     
            </TitleContainer>

            <SubTypeBarContainer>

                <FilterSelect name="SubTypeFilter"
                    {...register('SubTypeFilter', {
                        onChange: (e) => {
                         setSubTypeFilter(e.target.value);     
                        }
                    })}>

                    {stFilter.map((filter) => {
                        return <option value={filter[1]}>{filter[0]}</option>
                    })}

                </FilterSelect>

                <FilterSelect name="ArmorFilter"
                    {...register('ArmorFilter', {
                         onChange: (e) => {
                            setEquipFilter(e.target.value);
                        }
                    })}>
                    
                    {armFilter.map((filter) => {
                        return <option value={filter[1]}>{filter[0]}</option>
                    })}

                </FilterSelect>

                <FilterSelect name="PropertyFilter"
                    {...register('PropertyFilter', {
                        onChange: (e) => {
                            setPropertyFilter(e.target.value);
                        }
                    })}>

                    {pFilter.map((filter) => {
                        return <option value={filter[1]}>{filter[0]}</option>
                    })}

                </FilterSelect>

                <FilterSelect name="AtributeFilter"
                    {...register('AtributeFilter', {
                         onChange: (e) => {
                            setAtributeFilter(e.target.value.split(','));
                        }
                    })}>

                    {aFilter.map((filter) => {
                        return <option value={[filter[1],filter[2]]}>{filter[0]}</option>
                    })}

                </FilterSelect>

                <FilterSelect name="StatusFilter"
                    {...register('StatusFilter', {
                         onChange: (e) => {
                            setStatusFilter(e.target.value);
                        }
                    })}>
                    <option value="">Status</option>
                    <option value="">Todos</option>
                    <option value="Congelamento">Congelamento</option>
                    <option value="Caos">Caos</option>
                    <option value="Cegueira">Cegueira</option>
                    <option value="Silencio">Silêncio</option>
                    <option value="Envenenamento">Envenenamento</option>
                    <option value="Maldição">Maldição</option>
                    <option value="Alucinação">Alucinação</option>

                </FilterSelect>

            </SubTypeBarContainer>

            

            <PaginationContainer>
                 {paginationList}
            </PaginationContainer>

            <PaginationContainerIncrementer>
                 <IntervalPartitionIncrementer onClick={() => {
                    resetarScroll();

                    if(selectedInterval == 1) {
                        return
                    } else {
                        setSelectedInterval(selectedInterval - 1)
                    }
                    }}> ← 
                </IntervalPartitionIncrementer>
                <IntervalPartitionIncrementer onClick={() => {
                    resetarScroll();

                    if(selectedInterval > amountOfIntervals) {
                        return
                    } else {
                        setSelectedInterval(selectedInterval + 1)
                    }
                    }}> →
                </IntervalPartitionIncrementer>
            </PaginationContainerIncrementer>

            <MiddleContainer>
                <PopUpWarning />
                <H3>Intervalo: {selectedInterval}</H3>
                <H2>{typeDescriptionFilter}</H2>
                <H1>{resultsFounds} resultados encontrados</H1>
            </MiddleContainer>

            <ItemListMasterContainer>

                {nadaEncontrado}

                {splitedList.map((itemId) =>{

                if(itemId === 0) { return ;}

                let description = ItemDescriptionMapConsult(itemId).identifiedDescriptionName;

                description = aplicarCores(description)
                .replaceAll("--------------------------", "--------------------------<br>")
                .replaceAll("_______________________", "_______________________<br><br>")
                .replaceAll(" _____", "<br>_____")
                .replaceAll("|", "")
                .replaceAll("Peso:", "<br>Peso:")
                .replaceAll("Weight:", "<br>Weight:")
                .replaceAll("Nível da arma:", "<br>Nível da arma:")
                .replaceAll("Weapon Level:", "<br>Weapon Level:")
                .replaceAll("Tipo:", "<br>Tipo:")
                .replaceAll("Type:", "<br>Type:")
                .replaceAll("Defesa:", "<br>Defesa:")
                .replaceAll("Defense:", "<br>Defense:")
                .replaceAll("Força de ataque:", "<br>Força de ataque:")
                .replaceAll("Attack:", "<br>Attack:")
                .replaceAll("Nível da Arma:", "<br>Nível da Arma:")
                .replaceAll("Nível necessário:", "<br>Nível necessário:")
                .replaceAll("Classes que utilizam:", "<br><br>Classes que utilizam:")
                .replaceAll("Classes:", "<br><br>Classes:")
                .replaceAll("Classe:", "<br>Classe:")
                .replaceAll(".", ".<br>")
                .replaceAll("máx.<br>", "máx.")
                .replaceAll("máx. <br>", "máx.")
                .replaceAll("máx.<br> ", "máx.")
                .replaceAll("máx. <br> ", "máx.")
                .replaceAll("nv.<br>", "nv.")
                .replaceAll("nv. <br>", "nv.")
                .replaceAll("nv.<br> ", "nv.")
                .replaceAll("Equipa em:", "<br>Equipa em:")
                .replaceAll("Força de Ataque:", "<br>Força de Ataque:");

                let RoCollection;

                if(ItemTypeAndSubTypeConsult(itemId).Type === "Card"){
                     RoCollection = <RoItemCollection img={CheckCorrupted(ItemIdToNameAndResourceConsult(itemId).identifiedResourceName)}
                     onMouseOver={(event) => {
                        OpenPopMenu();
                        setPopMenuContent(<CardImage img={CardBmpMap(itemId)}/>);
                        //setToolTipContent(<CardImage img={CardBmpMap()[item.id]}/>);
                    }}
                    onMouseLeave={() => {
                        //setPopMenuContent(<></>)
                    }}/>                
                } else {
                     RoCollection = <RoItemCollection img={CheckCorrupted(ItemIdToNameAndResourceConsult(itemId).identifiedResourceName)}/>
                }

                let slotSet = [] ;
                let slotContainer = '';
                
                if(ItemTypeAndSubTypeConsult(itemId).Type === "Armor" || ItemTypeAndSubTypeConsult(itemId).Type === "Weapon") {
                
                    for(let i = 1; i < 5; i++) {
                    
                        if(ItemSlotCountConsult(itemId).Slots >= i)
                            { slotSet.push(<Slot img={OpenSlot}/>); } 
                            else {
                                slotSet.push(<Slot img={ClosedSlot}/>);
                            }
                    }

                    slotContainer = <SlotsContainer 
                        onMouseOver={(event) => TipMouseOverEvent(event, `Slots: ${ItemSlotCountConsult(itemId).Slots}`, "rgba(50, 107, 186, 1)")}
                        onMouseLeave={() => TipMouseOutEvent()}
                    >{slotSet}</SlotsContainer>;
                }

                return(
                <RoItemMasterContainer>
                    <RoItemHeader>
                        <RoItemIcon img={CheckCorrupted(ItemIdToNameAndResourceConsult(itemId).identifiedResourceName)}/>
                        <RoItemName>
                            {ItemIdToNameAndResourceConsult(itemId).identifiedDisplayName} - {itemId} - {ItemTypeAndSubTypeConsult(itemId).Type}
                        </RoItemName>
                    </RoItemHeader>

                    <RoItemBody>
                        {RoCollection}
                        <RoItemDescription dangerouslySetInnerHTML={{ __html: description }}/>
                    </RoItemBody>
                    {slotContainer}

                    <MonsterDropsContainer>
                        {MobDropByItemNameListConsult(ItemListRepoConsult(itemId).AegisName).map((drop) => {

                            if(drop.Item == ItemListRepoConsult(itemId).AegisName) {
                                return(
                                    <DropContainer
                                        onMouseOver={(event) => {
                                            let linkImg = "database/monster/" + MonsterMap(drop.MonsterId).toLowerCase() + ".gif"

                                            setToolTipContent(<MobImage src={linkImg} />)
                                            MobTipMouseOverEvent(event, `${drop.Name}  - (${drop.MonsterId})`, "rgba(0,0,0,1)"); }}

                                        onMouseLeave={() => {
                                            MobTipMouseOutEvent()
                                            }}

                                        onClick={() => {

                                            let SpawnMapList = MapaMonstro(drop.MonsterId)

                                            if(SpawnMapList == null){
                                                OpenPopMenu();
                                                setPopMenuContent(
                                                    <MapContainer>
                                                        <MapContainerItem>
                                                            Monstro de Quest / Instância.
                                                        </MapContainerItem>
                                                    </MapContainer>)

                                                return;
                                            }

                                            let mapList = []
                                            
                                            SpawnMapList.map((map) => {
                                                let mapAdress = "database/maps/" + map.location + ".png";

                                                mapList.push(
                                                    <MapContainerItem>

                                                        <MapTitle>{map.location} ({map.quantity})</MapTitle>

                                                        <MapImage src={mapAdress} />

                                                    </MapContainerItem>
                                                )
                                            })
                                            OpenPopMenu();
                                            setPopMenuContent(<MapContainer>{mapList}</MapContainer>);
                                        }}>
                                        {drop.Name} 
                                        <DropChance>({drop.Rate/100}%)</DropChance>
                                    </DropContainer>
                                ) 
                            } else { return; }
                        })}
                    </MonsterDropsContainer>

                    <MvpDropsContainer>
                        {MvpDropByItemNameListConsult(ItemListRepoConsult(itemId).AegisName).map((drop) => {

                            if(drop.Item == ItemListRepoConsult(itemId).AegisName) {
                                return(
                                    <DropContainer
                                        onMouseOver={(event) => {
                                            let linkImg = "database/monster/" + MonsterMap(drop.MonsterId).toLowerCase() + ".gif"

                                            setToolTipContent(<MobImage src={linkImg} />)
                                            MobTipMouseOverEvent(event, `${drop.Name}  - (${drop.MonsterId})`, "rgba(0,0,0,1)"); }}

                                        onMouseLeave={() => {
                                            MobTipMouseOutEvent()
                                            }}

                                        onClick={() => {

                                            let SpawnMapList = MapaMonstro(drop.MonsterId)

                                            if(SpawnMapList == null){
                                                OpenPopMenu();
                                                setPopMenuContent(
                                                    <MapContainer>
                                                        <MapContainerItem>
                                                            Monstro de Quest / Instância.
                                                        </MapContainerItem>
                                                    </MapContainer>)

                                                return;
                                            }

                                            let mapList = []
                                            
                                            SpawnMapList.map((map) => {
                                                let mapAdress = "database/maps/" + map.location + ".png";

                                                mapList.push(
                                                    <MapContainerItem>

                                                        <MapTitle>{map.location} ({map.quantity})</MapTitle>

                                                        <MapImage src={mapAdress} />

                                                    </MapContainerItem>
                                                )
                                            })
                                            OpenPopMenu();
                                            setPopMenuContent(<MapContainer>{mapList}</MapContainer>);
                                        }}>

                                        <MonsterIcon img={MvpType} />
                                        {drop.Name}
                                        <DropChance>({drop.Rate/100}%)</DropChance>
                                    </DropContainer>
                                ) 
                            } else { return; }
                        })}
                    </MvpDropsContainer>

                </RoItemMasterContainer>
                
                )}
                )}
        </ItemListMasterContainer>

        <PaginationContainerIncrementer>
                 <IntervalPartitionIncrementer onClick={() => {
                    resetarScroll();

                    if(selectedInterval == 1) {
                        return
                    } else {
                        setSelectedInterval(selectedInterval - 1)
                    }
                    }}> ← 
                </IntervalPartitionIncrementer>
                <IntervalPartitionIncrementer onClick={() => {
                    resetarScroll();

                    if(selectedInterval > amountOfIntervals) {
                        return
                    } else {
                        setSelectedInterval(selectedInterval + 1)
                    }
                    }}> →
                </IntervalPartitionIncrementer>
            </PaginationContainerIncrementer>

        </DatabaseContainer>

    );
}

export default ItemsDatabase;

const DatabaseContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1100px;
    text-align: center;
    transition: 2s;
    margin-bottom: 50px;
    opacity: 1;
    //border: solid;

    @media (max-width: 1000px) {
    width: 95vw;
    margin-top: 30px;
    }

`;

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1100px;
    //border: solid;
    margin-bottom: 20px;

    @media (max-width: 1000px) {
    width: 90%;
    //text-align: justify;
    margin-bottom: 50px;
    }
`;

const Title = styled.h1`
    font-size: 30pt;

    @media (max-width: 1000px) {
    font-size: 28pt;
    text-align: center;
    }
`;

const T1 = styled.div`
    width: 1000px;
    padding: 10px 20px;
    //border: solid;
    text-align: center;
    font-size: 13pt;


    @media (max-width: 1000px) {
    width: 100%;
    overflow: auto;
    padding: 10px;
    border-radius: 10px;
    //box-shadow: 0 0 10px 0 black;
    font-size: 11pt;
    }

`;

const SearchBarContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: 5px;
    padding: 10px;
    background-color:rgba(0,0,0,.5);
    margin-bottom: 0px;

    @media (max-width: 1000px) {
        width: 90vw;
        flex-direction: column;
        padding: 10px;
    }

`

const Input = styled.input`
    font-size: 12pt;
    width: 250px;
    padding: 5px;
    height: 30px;
    border-radius: 5px;
    border: solid 0px;
    background-color: rgba(0, 0, 0, 0.4);
    text-align: center;
    margin-right: 20px;
    color: white;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    @media (max-width: 1000px) {
        width: 90vw;
        padding: 10px 0px;
        margin-right: 0px;
        margin-bottom: 10px;
    }
`

const CategoryContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    //border: solid;
    margin-right: 20px;

    @media (max-width: 1000px) {
        width: 90vw;
        margin-right: 0px;
    }

`

const CategoryItem = styled.div`
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 30px;
    height: 30px;
    transition: .2s ease-in-out;
    margin: 0 5px;
    //border: solid 1px;
    filter: saturate(0);

    &:hover {
    filter: saturate(1);
    scale: 1.2;
    box-shadow: 2px 2px 2px 0 black;
    }

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        scale: 1;
        opacity: .5;
    }
`

const Submit = styled.div`
    font-size: 14pt;
    padding: 5px 5px;
    border-radius: 5px;
    border: solid 1px;
    background-color: rgba(5, 91, 144, 1);
    color: white;
    transition: .2s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:hover {
        box-shadow: 0 0 5px 0 black;
        scale: 1.1;
    }

    &:active {
        cursor: url('cursors0008.png'), pointer;
        scale: .7;
        opacity: .5;
    }

    @media (max-width: 1000px) {
        display: flex;
        justify-content: center;
        width: 90vw;
        padding: 10px 0;
        margin-right: 0px;
        margin-top: 10px;
    }
        
`

const SubmitIcon = styled.div`
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 30px;
    height: 30px;
`

const SubTypeBarContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: 5px;
    padding: 10px;
    background-color:rgba(0,0,0,.5);
    margin-bottom: 50px;

    @media (max-width: 1000px) {
    width: 90vw;
    flex-direction: column;
    padding: 10px;
    }

`

const FilterSelect = styled.select`
    font-size: 12pt;
    width: 150px;
    padding: 5px;
    height: 40px;
    border-radius: 5px;
    border: solid 0px;
    background-color: rgba(0, 0, 0, 0.4);
    text-align: center;
    margin-right: 10px;
    color: white;
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    @media (max-width: 1000px) {
    width: 90vw;
    margin-right: 0px;
    margin-bottom: 5px;
    }
`

const MiddleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    width: 100%;
    margin-bottom: 30px;

    @media (max-width: 1000px) {
        width: 90vw;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
    }
`

const H1 = styled.span`
    font-size: 12pt;
    text-align: center;
    //font-weight: bold;

    //border: solid 1px;
    padding: 10px 20px;
    border-radius: 10px;
    background-color: rgba(5, 91, 144, .8);
    color: white;

`
const H2 = styled.span`
    font-size: 12pt;
    text-align: center;
    //font-weight: bold;
    //border: solid 1px;
    padding: 10px 20px;
    border-radius: 10px;
    background-color: rgba(18, 129, 22, 0.8);
    color: white;
    margin-right: 10px;

    @media (max-width: 1000px) {
        margin-bottom: 10px;
        margin-right: 0px;
    }

`

const H3 = styled.span`
    font-size: 12pt;
    text-align: center;
    //font-weight: bold;
    //border: solid 1px;
    padding: 10px 20px;
    border-radius: 10px;
    background-color: rgba(10, 9, 9, 0.8);
    color: white;
    margin-right: 10px;
    margin-left: 10px;

    @media (max-width: 1000px) {
        margin-bottom: 10px;
        margin-right: 0px;
    }

`

const ItemListMasterContainer = styled.div`
    display: flex;
    //flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    //border: solid;
    width: 100%;

`

const RoItemMasterContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    //border: solid 1px;
    border-radius: 10px;
    //padding: 10px 30px;
    transition: .2s ease-in-out;
    margin: 10px 10px;
    //box-shadow: 0 0 3px 0 black;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    &:hover {
    //box-shadow: 0 0 5px 0px black;
    scale: 1.1;
    z-index: 2;
    background-color: white;
    }

    @media (max-width: 1000px) {
    scale: .9;
    margin-bottom: 5px;

        &:hover {
            scale: 1;
        }
    }
`

const RoItemHeader = styled.div`
    display: flex;
    align-items: center;
    border-radius: 10px;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: 5px;
    padding: 5px 0px;
    background-color:rgba(0, 0, 0, 0.7);
`
const RoItemIcon = styled.div`
    background-image: url('/database/itemPng/${props => props.img}.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    margin: 0 20px;
    
`
const RoItemName = styled.div`
    display: flex;
    align-items: center;
    //border-bottom: solid 1px rgba(0,0,0,.3);
    width: 100%;
    padding: 10px 5px;
    font-size: 14pt;
    font-weight: bold;
    color: white;
`

const RoItemBody = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    //border: solid 1px rgba(0,0,0,.2);
    border-radius: 10px;
    padding: 30px 0;
`

const RoItemCollection = styled.div`
    background-image: url('/database/collection/${props => props.img}.bmp');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 75px;
    height: 100px;
    margin: 0 20px;
    //box-shadow: 2px 2px 0 0 rgba(0,0,0,.2);
`

const RoItemDescription = styled.div`
    width: 1000px;
    text-align: left;
    padding: 0 20px;
    //border: solid 1px;

    @media (max-width: 1000px) {
    width: 60vw;
    padding: 5px
    }
`

const CardImage = styled.div`
    background-image: url('/database/cardbmp/${props => props.img}.bmp');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 345px;
    height: 470px;
    //width: 220px;
    //height: 300px;
    box-shadow: 0 0 10px 0px black;
    border-radius: 10px;
    border: solid 1px;
    z-index: 30;

    @media (max-width: 1000px) {
    width: 600px;
    height: 800px;
    }


`

const SlotsContainer = styled.div`
    //border: solid 1px rgba(0,0,0,.2);
    border-radius: 10px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: start;
    padding-left: 5px;
`

const Slot = styled.div`
    background-image: url('${props => props.img}');
    background-size: cover;
    background-repeat: no-repeat;
    backrgound-position: center center;
    width: 30px;
    height: 30px;

`

const MonsterDropsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    flex-wrap: wrap;
    padding: 5px 0;
    width: 100%;
    //border: solid 1px;
    transition: .3s ease-in-out;
    margin-top: 30px;

    &:hover {
    height: 100%;
    }

    @media (max-width: 1000px) {
        width: 100%;
        padding: 5px;
    
    }

`

const MvpDropsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    flex-wrap: wrap;
    padding: 5px 0;
    width: 100%;
    //border: solid 1px;
    transition: .3s ease-in-out;
    margin-top: 0px;

    &:hover {
    height: 100%;
    }

    @media (max-width: 1000px) {
        width: 100%;
        padding: 5px;
    
    }

`

const DropContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
    //border: solid 1px;
    border-radius: 10px;
    margin: 0 10px 10px 0;
    font-size: 10pt;
    transition: .3s ease-in-out;

    &:hover {
    scale: 1.1;
    z-index: 5;

    background-color: rgba(0, 0, 0, 1);
    color: white;
    }
`

const ItemName = styled.span`
    
`
const MonsterIcon = styled.div`
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 35px;
    height: 35px;
    margin-right: 5px;
    //border: solid;
    transition: .3s ease-in-out;
    
`
const DropChance = styled.span`
    font-weight: bold;
    margin-left: 5px;
`

const MobImage = styled.img`
    border-radius: 10px;
    padding: 20px;
    scale: 1.3;
    margin-bottom: 30px;
    background-color: rgba(0, 0, 0, .7);
    border: solid 1px;
    box-shadow: 5px 5px 5px 0 rgba(0,0,0,.7);
`


const MapContainer = styled.div`
    display: flex;
    align-itens: center;
    justify-content: start;
    flex-wrap: wrap;
    width: 100%;
    background-color: rgba(0, 0, 0, .7);
    border: solid 1px;
    box-shadow: 5px 5px 5px 0 rgba(0,0,0,.7);
    border-radius: 10px;
    padding: 20px;
    }

    @media (max-width: 1000px) {
        width: 100vw;
        padding: 5px;
    
    }
`

const MapTitle = styled.span`
    font-size: 17pt;
    text-align: center;
    margin-bottom: 10px;

`

const MapContainerItem = styled.div`
    display: flex;
    flex-direction: column;
    align-itens: center;
    justify-content: center;
    //border: solid 1px;
    border-radius: 10px;
    font-size: 14pt;
    margin: 0 20px;
    color: white;
    transition: .3s ease-in-out;
`

const MapImage = styled.img`
    width: 200px;
    height: 200px;
    background-color: black;
`

const PaginationContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
    margin-bottom: 0px;
    flex-wrap: wrap;
    overflow-y: auto;
    max-height: 100px;
    padding: 10px 10px;
    //border: 1px solid rgba(0,0,0,.1);
    background-color: rgba(0,0,0,.5);
    border-radius: 5px;

    @media (max-width: 1000px) {
        width: 90vw;
        //flex-direction: column;
        align-items: center;
        justify-content: start;
    }
`

const IntervalPartition = styled.div`
    border-radius: 5px;
    background-color: rgba(0,0,0,.7);
    color: white;
    padding: 5px 10px;
    margin-right: 5px;
    margin-bottom: 5px;
    transition: .2s ease-in-out;
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        scale: .5;
        opacity: .5;
    }

    &:hover {
        box-shadow: 0 0 2px 0px black;
        scale: 1.1;
        z-index: 2;
        background-color: rgba(144, 5, 5, 1);
    }
`

const PaginationContainerIncrementer = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
    margin-bottom: 0px;
    flex-wrap: wrap;
    overflow-y: auto;
    max-height: 95px;
    padding: 10px;

    @media (max-width: 1000px) {
        width: 90vw;
        //flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`

const IntervalPartitionIncrementer = styled.div`
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 5px 10px;
    margin-top: 20px;
    margin-bottom: 5px;
    margin-right: 10px;
    transition: .2s ease-in-out;
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    &:hover {
        box-shadow: 0 0 2px 0px black;
        scale: 1.5;
        z-index: 2;
        background-color: rgba(0,0,0,.8);
    }
`